<style lang="scss" scoped>
  select {
    min-width: 200px;
  }
  .table {
    width: 100%;
  }
  .textarea:not([rows]) {
    min-height: 20em;
  }
  .updated {
    color: #dfa1a1;
    weight: light;
  }
</style>


<template>
  <c-layout>
    <template #title>Dashboard</template>

    <template v-if="!user.subscriber" #content>
      <div class="is-size-6 pb-5">
        <div class="heading mb-5"></div>
        <p class="is-size-4">
          Want to see your diode data here?
          <a class="has-text-danger" target="_blank" href="https://www.fend.tech/fend-cloud">
            Check out Fend Cloud
          </a>
        </p>
      </div>
      <div class="columns">
        <div class="column">

        </div>
      </div>
    </template>

    <template v-else #content>
      <div class="columns">
        <div class="column">
          <div class="heading">Devices</div>

          <!-- select diode -->
          <div class="select mr-5">
            <select v-model="selected" @change="reset">
              <option disabled value="null">Select device</option>
              <option v-for="device in devices" :key="device.id" :value="device">{{device.serial}}</option>
            </select>
          </div>

          <!-- select protocol -->
          <div class="select">
            <select v-model="protocol">
              <option disabled value="null">Select protocol</option>
              <option value="modbus">{{title('modbus')}}</option>
              <option value="lon">{{title('lon')}}</option>
              <option value="bac">{{title('bac')}}</option>
              <!-- <option disabled value="custom">Custom protocol...</option> -->
            </select>
          </div>
      </div>
      </div>

      <div class="columns">
        <!-- event stream -->
        <div class="column is-half">
          <div class="heading">Events</div>
          <stream :events="poller.events"/>
        </div>

        <!-- protocol -->
        <div class="column is-half">
          <div class="heading">{{title(protocol)}}</div>
          <modbus v-if="protocol === 'modbus'" :events="poller.events" :diode="selected"/>
          <lon v-if="protocol === 'lon'" :events="poller.events" :diode="selected"/>
          <bac v-if="protocol === 'bac'" :events="poller.events" :diode="selected"/>
        </div>
      </div>
    </template>

  </c-layout>
</template>

<script>
import api from '@/api';
import { get } from 'vuex-pathify';
import Poller from '@/utils/poller';
import Device from '@/models/device';
import Stream from '@/components/stream';
import Modbus from './modbus';
import Lon from './lon';
import Bac from './bac';

const mapping = {
  'modbus': 'modbus',
  'modbusTCP': 'modbus',
  'modbusRTU': 'modbus',
  'LON/IP': 'lon',
  'BACnetIP': 'bac'
};

const titles = {
  'modbus': 'modbus',
  'lon': 'LON IP',
  'bac': 'BACnet'
};

export default {
  name: 'dashboard',
  components: {
    Stream,
    Modbus,
    Lon,
    Bac
  },
  data() {
    return {
      selected: null,
      protocol: 'protocol',
      poller: new Poller({
        retrieve: async (position) => {
          if (!this.selected) return [];
          return api.events.index(this.selected.serial, {
            after: position,
            limit: 100
          });
        },
        fence: (events) => {
          return (!this.selected || this.selected.serial !== events[0].diode);
        },
        received: (events) => {
          if (this.protocol === 'protocol') {
            const selection = mapping[events[0].type];
            if (selection) this.protocol = selection;
          }
        }
      })
    };
  },
  computed: {
    devices: () => Device.all(),
    user: get('user')
  },
  methods: {
    reset() {
      this.protocol = 'protocol';
      this.poller.reset();
    },
    title(protocol) {
      return titles[protocol] || protocol;
    }
  },
  created() {
    this.poller.start();
    api.devices.load();
  },
  destroyed () {
    this.poller.stop();
  }
};
</script>
